import PRODUCT_FEATURES, {
  CHECK_SYMPTOMS,
  BOOK_APPOINTMENT,
  PRESCRIPTION,
} from './productFeatures'
import CONTENT from './content'
import CONTENT_V2, {
  contentWithFamily as CONTENT_WITH_FAMILY_V2,
  contentWithEligibility as CONTENT_WITH_ELIGIBILITY_V2,
  contentWithFamilyAndEligibility as CONTENT_WITH_FAMILY_AND_ELIGIBILITY_V2,
} from './contentV2'
import CONFIG, {
  configWithFamilyProps as CONFIG_WITH_FAMILY,
  configWithFamilyAndEligibilityProps as CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
  configWithEligibilityProps as CONFIG_WITH_ELIGIBILITY,
} from './config'
import CONFIG_V2, {
  configWithFamilyPropsV2 as CONFIG_WITH_FAMILY_V2,
  configWithFamilyAndEligibilityPropsV2 as CONFIG_WITH_FAMILY_AND_ELIGIBILITY_V2,
  configWithEligibilityPropsV2 as CONFIG_WITH_ELIGIBILITY_V2,
} from './configV2'

const USA = {
  PRODUCT_FEATURES,
  CONTENT,
  CONFIG,
  CONFIG_WITH_FAMILY,
  CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
  CHECK_SYMPTOMS,
  BOOK_APPOINTMENT,
  PRESCRIPTION,
  CONTENT_V2,
  CONTENT_WITH_FAMILY_V2,
  CONTENT_WITH_ELIGIBILITY_V2,
  CONTENT_WITH_FAMILY_AND_ELIGIBILITY_V2,
  CONFIG_V2,
  CONFIG_WITH_FAMILY_V2,
  CONFIG_WITH_FAMILY_AND_ELIGIBILITY_V2,
  CONFIG_WITH_ELIGIBILITY,
  CONFIG_WITH_ELIGIBILITY_V2,
}

export default USA
